import { getTrackingEventSystemProperties } from "@features/tracking/getSystemProperties";
import {
  Event,
  SystemProperties,
  trackingService,
} from "@motain/web-shared-hub/features";
import { isNullish } from "@motain/web-shared-hub/helpers";

export const sendTrackingEventWithSysProps = async (event: Event) => {
  const { name, properties } = event;
  let sysProps: SystemProperties | null = null;
  try {
    sysProps = await getTrackingEventSystemProperties();
  } catch {
    // fails in silence and sadness
  }

  trackingService.sendEvent({
    name,
    properties: {
      ...properties,
      ...(!isNullish(sysProps) && sysProps),
    },
  });
};
